/**
 * Service-worker registration without workbox-window. The generated SW
 * (registerType 'autoUpdate') calls skipWaiting + clientsClaim itself, so an
 * update takes over on the next navigation; we surface it so the user can
 * reload sooner.
 */
export type UpdateListener = (needRefresh: boolean) => void;

const listeners = new Set<UpdateListener>();
let needRefresh = false;

export function onSwUpdate(listener: UpdateListener): () => void {
  listeners.add(listener);
  listener(needRefresh);
  return () => listeners.delete(listener);
}

function setNeedRefresh(value: boolean) {
  needRefresh = value;
  for (const l of listeners) l(value);
}

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    // updateViaCache 'none': nginx pins *.js for 30 days, and the worker
    // importScripts sw-notifications.js — update checks must bypass that cache.
    navigator.serviceWorker
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const worker = registration.installing;
          if (!worker) return;
          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              setNeedRefresh(true);
            }
          });
        });
      })
      .catch((err: unknown) => console.warn('service worker registration failed', err));
  });
}

export function reloadForUpdate(): void {
  setNeedRefresh(false);
  window.location.reload();
}

export function dismissUpdate(): void {
  setNeedRefresh(false);
}
